import { render, staticRenderFns } from "./DressageLevel.vue?vue&type=template&id=85ee2b70&"
import script from "./DressageLevel.vue?vue&type=script&lang=js&"
export * from "./DressageLevel.vue?vue&type=script&lang=js&"
import style0 from "./DressageLevel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports